import { getAll } from "../utilities/querySelector";

const observer = new ResizeObserver( cardResizeHandler );

getAll( '[class^=card--]' ).forEach( card => observer.observe( card ) );

function cardResizeHandler(entries) {
    entries.forEach( entry => {
        if ( !entry.borderBoxSize ) return;
        const card = entry.target;
        const { inlineSize } = entry.borderBoxSize[0];
        setSizeClass( card, inlineSize );
    });
}

function setSizeClass( card, size ) {
    card.classList.remove( 'is-size-large', 'is-size-medium', 'is-size-small', 'is-size-xlarge' );
    card.classList.add( widthToClass( size ) );
}

function widthToClass( width ) {
    if ( width > 650 ) {
        return 'is-size-xlarge';
    } else if (width > 575) {
        return 'is-size-large';
    } else if ( width > 400 ) {
        return 'is-size-medium'
    } else {
        return 'is-size-small'
    }
}
